import { render } from "./CustomStepper.vue?vue&type=template&id=04b2f733"
import script from "./CustomStepper.vue?vue&type=script&lang=js"
export * from "./CustomStepper.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__